/** Logo „REC" (punct pulsatoriu) + wordmark opțional „Reclame Video". */
export function Logo({ withWordmark = false }: { withWordmark?: boolean }) {
  return (
    <>
      <span
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: 7,
          background: 'var(--ink)',
          color: 'var(--bg)',
          padding: '7px 10px',
          borderRadius: 999,
          fontSize: 11,
          letterSpacing: '.14em',
          fontWeight: 800,
        }}
      >
        <span
          style={{
            width: 7,
            height: 7,
            borderRadius: '50%',
            background: 'var(--accent)',
            boxShadow: '0 0 10px 1px rgba(232,78,54,.6)',
            animation: 'rv-pulse 2.2s ease-in-out infinite',
          }}
        />
        REC
      </span>
      {withWordmark && (
        <span className="bricolage" style={{ fontWeight: 800, fontSize: 16 }}>
          Reclame Video
        </span>
      )}
    </>
  );
}
